import { Wordpress } from '../types/Wordpress'
import { ActionTree } from 'vuex';
import * as types from './mutation-types'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import SearchAdapter from '../lib/searchAdapter'

const storeView = currentStoreView()
const searchAdapter = new SearchAdapter()

// it's a good practice for all actions to return Promises with effect of their execution
export const actions: ActionTree<Wordpress, any> = {
  // if you want to use cache in your module you can load cached data like this
  loadPost ({ commit }, { slug }) {
    return new Promise((resolve, reject) => {
      // let query = 'query post ($id: ID!) { post(id: $id) { title date uri link content(format: RAW) } }'
      let query = 'query GET_POST($slug: String!) { postBy(slug: $slug) { title date slug excerpt categories { edges { node{name} } } featuredImage { node { sourceUrl } } content seo { title metaDesc } } }'

      const Request = {
        store: storeView.storeCode,
        query: query,
        queryVars: { slug }
      }

      searchAdapter.search(Request).then((resp) => {
        commit(types.SET_CURRENTPOST, resp.data.postBy)
        resolve(resp.data.postBy)
      }, error => {
        reject(error)
      })
    })
  },
  loadPosts ({ commit, state }, { first }) {
    return new Promise((resolve, reject) => {
      let query = 'query GET_POSTS($first: Int) { posts(first: $first) { nodes { id title date slug excerpt featuredImage { node { sourceUrl } } } } seo { meta { homepage { title description } } } }'
      // let query = 'query GET_POSTS($first: Int) { posts(first: $first) { nodes { id title date slug excerpt categories { edges { node{name} } } featuredImage { sourceUrl } } } }'

      const Request = {
        store: storeView.storeCode,
        query: query,
        queryVars: { first }
      }

      searchAdapter.search(Request).then((resp) => {
        let posts = resp.data.posts.nodes
        const homepage = resp.data.seo && resp.data.seo.meta && resp.data.seo.meta.homepage
        commit(types.SET_POSTS, posts)
        commit(types.SET_ARCHIVE_SEO, homepage || { title: '', description: '' })
        resolve(posts)
      }, error => {
        reject(error)
      })
    })
  },
  loadCategories ({ commit, state }, { first }) {
    return new Promise((resolve, reject) => {
      let query = 'query GET_CATEGORIES($first: Int) { categories(first: $first) { nodes { id name slug children { edges { node { id name slug } } } } } }'

      const Request = {
        store: storeView.storeCode,
        query: query,
        queryVars: { first }
      }

      searchAdapter.search(Request).then((resp) => {
        let categories = resp.data.categories.nodes
        commit(types.SET_CATEGORIES, categories)
        resolve(categories)
      }, error => {
        reject(error)
      })
    })
  },
  loadCategoryBySlug ({ commit }, { slug }) {
    return new Promise((resolve, reject) => {
      let query = 'query GET_CATEGORY { categories(where: {slug: "' + slug + '"}) { nodes { id name slug children { edges { node { id name slug } } } posts { nodes { id title date slug excerpt featuredImage { node { sourceUrl } } } } } } }'

      const Request = {
        store: storeView.storeCode,
        query: query,
        queryVars: {}
      }

      searchAdapter.search(Request).then((resp) => {
        commit(types.SET_CURRENTCATEGORY, resp.data.categories.nodes[0])
        resolve(resp.data.categories.nodes[0])
      }, error => {
        reject(error)
      })
    })
  },
  loadCategoryById ({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      let query = 'query category ($id: ID!) { category(id: $id) { id name slug children { edges { node { id name slug } } } posts { nodes { id title date slug excerpt featuredImage { node { sourceUrl } } } } } }'

      const Request = {
        store: storeView.storeCode,
        query: query,
        queryVars: { id }
      }

      searchAdapter.search(Request).then((resp) => {
        commit(types.SET_CURRENTCATEGORY, resp.data.category)
        resolve(resp.data.category)
      }, error => {
        reject(error)
      })
    })
  }
}
